import { Controller } from "@hotwired/stimulus";
import { i18n } from "../lib/i18n";

// Option 1: Animated Dots with rotating messages
// Cycles through messages with animated dots and fade transitions
export default class extends Controller {
  static targets = ["text"];
  
  connect() {
    this.messages = [
      i18n.t('ai_loading_dots.thinking'),
      i18n.t('ai_loading_dots.analyzing'),
      i18n.t('ai_loading_dots.processing'),
      i18n.t('ai_loading_dots.summarizing'),
      i18n.t('ai_loading_dots.reviewing'),
      i18n.t('ai_loading_dots.generating'),
    ];
    this.dots = ["", ".", "..", "..."];
    this.currentMessageIndex = 0;
    this.currentDotIndex = 0;
    this.dotCycles = 0; // Track how many full dot cycles we've done
    this.startAnimation();
  }

  disconnect() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  startAnimation() {
    this.updateText();

    // Cycle through dots every 400ms
    this.intervalId = setInterval(() => {
      this.currentDotIndex = (this.currentDotIndex + 1) % this.dots.length;

      // After completing a full cycle of dots (back to 0), increment cycle count
      if (this.currentDotIndex === 0) {
        this.dotCycles++;

        // After 2 full dot cycles, change the message with fade effect
        if (this.dotCycles >= 2) {
          this.fadeOutAndChangeMessage();
          this.dotCycles = 0;
        } else {
          this.updateText();
        }
      } else {
        this.updateText();
      }
    }, 400);
  }

  fadeOutAndChangeMessage() {
    // Fade out
    this.textTarget.style.opacity = "0";

    setTimeout(() => {
      // Change message while invisible
      this.currentMessageIndex =
        (this.currentMessageIndex + 1) % this.messages.length;
      this.updateText();

      // Fade in
      setTimeout(() => {
        this.textTarget.style.opacity = "1";
      }, 50);
    }, 300);
  }

  updateText() {
    this.textTarget.textContent =
      this.messages[this.currentMessageIndex] + this.dots[this.currentDotIndex];
  }
}
